var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "gfu-block-editor-prefix",
        { _jcc: _vm.iconPosition === "center" },
      ],
    },
    [
      _vm.icon
        ? [
            _vm.iconDescription
              ? _c(
                  "tooltip",
                  { attrs: { text: _vm.iconDescription } },
                  [
                    _c("base-icon", {
                      attrs: { name: _vm.icon, draggable: "false" },
                    }),
                  ],
                  1
                )
              : _c("base-icon", {
                  attrs: { name: _vm.icon, draggable: "false" },
                }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }